import delana from '../assets/board/delana.png';
import marc from '../assets/board/marc.png';
import joe from '../assets/board/joe.png';
import tom from '../assets/board/tom.png';
import joni from '../assets/board/joni.png';
import stephanie from '../assets/board/stephanie.png';

export const MEMBERS = [
    {
        name: 'Delana Rauterkus',
        role: 'President',
        picture: delana,
    },
    {
        name: 'Marc Ferguson',
        role: 'VP - Chief Financial Officer',
        picture: marc,
    },
    {
        name: 'Joe Pruch',
        role: 'VP - Business Development and Communications',
        picture: joe,
    },
    {
        name: 'Tom Kiefer',
        role: 'VP - Business Development and Communications',
        picture: tom,
    },
    {
        name: 'Joni Wheeler',
        role: 'VP - Chief Financial Officer',
        picture: joni,
    },
    {
        name: 'Dr. Stephanie Miske',
        role: 'VP - Chief Financial Officer',
        picture: stephanie,
    },
];
